module.exports = __webpack_public_path__ + "img/jpg.40ba81cb.svg";